import { Component, inject } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Evenement } from '../../models/evenement.class';
import { CarteAgendaComponent } from "../../components/carte-agenda/carte-agenda.component";

@Component({
  selector: 'app-atelier',
  imports: [AsyncPipe, CarteAgendaComponent],
  templateUrl: './atelier.component.html',
  styleUrl: './atelier.component.scss'
})
export class AtelierComponent {
  apiService: ApiService = inject(ApiService);
  route: ActivatedRoute = inject(ActivatedRoute);

  atelier$: Observable<any> = of(null);
  evenements$: Observable<Evenement[]> = of([]);

  ngOnInit(): void {
    const atelierUid: string | null = this.route.snapshot.paramMap.get('id');
    if (atelierUid) {
      this.atelier$ = this.apiService.getAterlier(atelierUid);
      this.evenements$ = this.apiService.getEvenementsFromAtelier(atelierUid);
    }
  }
}
